import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import bgImg from "../../assets/images/bgImg.png";
import brandLogo from "../../assets/logos/brandLogo.svg";
import AuthTextInput from "../../components/common/commonTextInputs/authTextInput";
import AuthButton from "../../components/common/commonButtons/authButton";
import mailbox from "../../assets/svg/mailbox.svg"
import { ForgoPasswordMailAPI } from "../../services/authServices";
import { Typography } from "@mui/material";
import CommonSnackbar from "../../components/common/toastMessage";

type ForgotPasswordState = {
  email: string;
  errors: {
    emailError: string;
    validationError: String;
  };
};

const ForgotPassword: React.FC = () => {
  const navigate = useNavigate();
  const [forgotInput, setforgotInput] = useState<ForgotPasswordState>({
    email: "",
    errors: {
      emailError: "",
      validationError: "",
    },
  });
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
    const [snackbar, setSnackbar] = useState({
      open: false,
      message: "",
      color: "green",
    });
  const [error, setErrors] = useState<any>({
    wholeError: false,
    emailError: false,
  });

  const validateForm = () => {
    let isValid = true;
    const newErrors = { emailError: "" };
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(forgotInput.email)) {
      setErrors((prev: any) => ({ ...prev, emailError: true }));
      newErrors.emailError = "Enter a valid email address.";
      isValid = false;
    }

    setforgotInput((prev: any) => ({ ...prev, errors: newErrors }));
    return isValid;
  };
  const handleBack = () => {
    navigate("/");
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setforgotInput((prev: any) => ({
      ...prev,
      [name]: value,
      errors: { ...prev.errors, [`${name}Error`]: "" },
    }));
  };

  const handleForgot = async () => {
    console.log("handle forghot");
    if (!validateForm()) return;

    let payload = { email: forgotInput.email.toLowerCase() };
    try {
      setLoading(true);
      const response = await ForgoPasswordMailAPI(payload);
      if(response.status === 200){
        // ✅ After success, switch to success screen
        setSubmitted(true);
        setSnackbar({
          open: true,
          message: "Password Reset Mail sent successfully",
          color: "green",
        });
      } else if(response.status === 400){
        setSnackbar({
          open: true,
          message: response.message || "Error occured while sending mail",
          color: "red",
        });
      }
    } catch (error: any) {
      // notifyError(error.message || "Something went wrong");
      console.log(error.message || "Something went wrong");

    } finally {
      setLoading(false);
    }

  };
  return (
    <>
      <div
        className="flex justify-center items-center w-[100%] h-screen bg-cover bg-center text-white"
        style={{ backgroundImage: `url(${bgImg})` }}
      >
        <div className="!w-[400px] flex justify-center items-center bg-authContainerBg border border-authContainerBg !rounded-2xl ">
          {submitted ? (
            <div className="!m-[1rem] w-[75%] flex flex-col justify-center items-center !my-[2rem]">
              <img
                src={brandLogo}
                alt="Awesome-Logo"
                className="!mb-[0.5rem] w-[1.7rem]"
              />
              <Typography
                variant="h5"
                className="font-bold text-[1.3rem] !my-[0.5rem]"
              >
                Check your email
              </Typography>
              <Typography
                variant="body1"
                className="text-[0.7rem] !mb-[1rem]"
              >
                We’ve sent a password reset link to <b>{forgotInput.email.toLowerCase()}</b>.
                Please check your inbox (and spam folder).
              </Typography>
              <AuthButton
                message="Back To Login"
                onClick={handleBack}
                classes="bg-gradient-to-r from-[#3BEBAA4D] to-[#3983DD] !font-bold !text-[0.8rem] !normal-case !text-white w-[100%] !rounded-[5px] h-[2.3rem] !p-[0.9rem]"
              />

            </div>
          ) : (
            <div className="!m-[1rem] w-[75%] flex flex-col justify-center items-center !my-[2rem]">
              <img
                src={brandLogo}
                alt="Awesome-Logo"
                className="!mb-[0.5rem] w-[1.7rem]"
              />
              <p className="font-bold text-[1.3rem] !my-[0.5rem]">
                Forgot Password !
              </p>
              <p className="text-[0.7rem] !mb-[1rem]">
                Enter Your Email Address{" "}
              </p>
              <AuthTextInput placeholder="Email" icon={mailbox}
                types="email"
                name="email"
                value={forgotInput.email}
                onChange={handleChange} />
              {!forgotInput.email ? (
                <span className="text-[0.8rem] text-red-500">
                  {forgotInput.errors.emailError}
                </span>
              ) : (
                error.emailError && (
                  <p className="text-[0.8rem] text-red-500 ">
                    {forgotInput.errors.emailError}
                  </p>
                )
              )}
              {error.wholeError && (
                <p className="text-[0.8rem] text-red-500 ">
                  {forgotInput.errors.validationError}
                </p>
              )}
              <AuthButton
                message={loading ? "Submitting..." : "Send Code"}
                onClick={handleForgot}
                classes="bg-gradient-to-r from-[#3BEBAA4D] to-[#3983DD] !font-bold !text-[0.8rem] !normal-case !text-white w-[100%] !rounded-[5px] h-[2.3rem] !p-[0.9rem]"
              />
              <p
                className="text-[0.7rem] !mt-[1rem] cursor-pointer"
                onClick={handleBack}
              >
                Back To Login{" "}
              </p>
            </div>
          )}
        </div>

        <CommonSnackbar
        open={snackbar.open}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        message={snackbar.message}
        backgroundColor={snackbar.color}
      />
      </div>
    </>
  );
};

export default ForgotPassword;
